"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorAddAdditionalDriverPayWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var AnnualMotorMtaExcessChangeBanner_1 = require("../../../components/annual/motor/AnnualMotorMtaExcessChangeBanner");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualMotorAddAdditionalDriverPayWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorAddAdditionalDriverPayWidget, _super);
    function AnnualMotorAddAdditionalDriverPayWidget(props) {
        return _super.call(this, props) || this;
    }
    AnnualMotorAddAdditionalDriverPayWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.renderOutputPanel()));
    };
    AnnualMotorAddAdditionalDriverPayWidget.prototype.renderOutputPanel = function () {
        var interaction = this.props.engine.getInteraction();
        var additionalPremium = interaction.factors.additionalPremium;
        var upfrontPaymentAmount = interaction.factors.upfrontPaymentAmount;
        var monthlyPaymentsSpread = interaction.factors.monthlyPaymentSpreadAmount;
        var refund = interaction.factors.returnPremium;
        var payFullPrice = interaction.uistate.payFullPrice;
        var tierChangeWording = (0, commonFunctions_1.getTierChangeWording)(interaction);
        window.sessionStorage.setItem("additionalPremium", String(additionalPremium));
        window.sessionStorage.setItem("upfrontPaymentAmount", String(upfrontPaymentAmount));
        window.sessionStorage.setItem("monthlyPaymentsSpread", String(monthlyPaymentsSpread));
        window.sessionStorage.setItem("payFullPrice", String(payFullPrice));
        var paymentRequired = additionalPremium > 0;
        var newAdditionalDriversCount = interaction.additionalDrivers.length - parseInt(window.sessionStorage.getItem("initialAdditionalDriversNumber"), 10);
        var additionalDrivers = interaction.additionalDrivers.slice(-newAdditionalDriversCount);
        var additionalDriversNames = additionalDrivers.map(function (driver, index) {
            return index === additionalDrivers.length - 1 ? React.createElement("span", null,
                driver.firstName,
                " ",
                driver.lastName) : React.createElement("span", null,
                driver.firstName,
                " ",
                driver.lastName,
                ", ");
        });
        var car = interaction.vehicles[0];
        var annualPremiumType = interaction.factors.premiumType === 'annual';
        var panelMessage = [];
        this.addAdditionalDriverToVehicleDrivers();
        var showSummaryPageWording = this.getSetting("showSummaryPageWording") === "true";
        if (upfrontPaymentAmount > 0 && !annualPremiumType && paymentRequired && !payFullPrice) {
            panelMessage.push(React.createElement(React.Fragment, null,
                React.createElement(AnnualMotorMtaExcessChangeBanner_1.AnnualMotorMtaExcessChangeBanner, { interaction: interaction }),
                React.createElement("div", { className: "panel policy-change-price" },
                    React.createElement("div", { className: "price font-family-display font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(additionalPremium)),
                    React.createElement("p", null, "All figures include Insurance Premium Tax"),
                    React.createElement("p", { className: "mb-0 font-weight-bold" },
                        "to add additional",
                        ' ',
                        additionalDrivers.length === 1 ? 'driver' : 'drivers',
                        " ",
                        additionalDriversNames,
                        " to",
                        ' ',
                        car.make,
                        ", ",
                        car.model,
                        " ",
                        car.registrationNumber,
                        " ",
                        tierChangeWording),
                    React.createElement("div", { className: "font-weight-bold" },
                        "Pay ",
                        (0, commonFunctions_1.getAmountToDisplay)(upfrontPaymentAmount),
                        " upfront now ",
                        this.getMonthlyPaymentWording(monthlyPaymentsSpread)),
                    this.renderRenewalWording(interaction))));
        }
        else if (paymentRequired) {
            panelMessage.push(React.createElement(React.Fragment, null,
                React.createElement(AnnualMotorMtaExcessChangeBanner_1.AnnualMotorMtaExcessChangeBanner, { interaction: interaction }),
                React.createElement("div", { className: "panel policy-change-price" },
                    showSummaryPageWording &&
                        React.createElement("div", null,
                            "You'll pay an additional ",
                            (0, commonFunctions_1.getAmountToDisplay)(additionalPremium),
                            " for your changes to cover you from the start date selected to the end of your policy."),
                    React.createElement("div", { className: "price font-family-display font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(additionalPremium)),
                    React.createElement("p", null, "All figures include Insurance Premium Tax"),
                    React.createElement("div", { className: "font-weight-bold" },
                        "to add additional",
                        ' ',
                        additionalDrivers.length === 1 ? 'driver' : 'drivers',
                        " ",
                        additionalDriversNames,
                        " to",
                        ' ',
                        car.make,
                        ", ",
                        car.model,
                        " ",
                        car.registrationNumber,
                        " ",
                        tierChangeWording),
                    this.renderRenewalWording(interaction))));
        }
        else if (refund > 0 && annualPremiumType) {
            panelMessage.push(React.createElement(React.Fragment, null,
                React.createElement(AnnualMotorMtaExcessChangeBanner_1.AnnualMotorMtaExcessChangeBanner, { interaction: interaction }),
                React.createElement("div", { className: "panel policy-change-price" },
                    showSummaryPageWording && React.createElement("div", null,
                        "You'll receive a refund of ",
                        (0, commonFunctions_1.getAmountToDisplay)(refund),
                        " for making this change."),
                    React.createElement("div", { className: "mb-0" },
                        React.createElement("div", { className: "price font-family-display font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(refund)),
                        React.createElement("p", null,
                            React.createElement("span", { className: "font-weight-bold" }, "refund "),
                            "for adding ",
                            additionalDriversNames,
                            " to your car policy",
                            !(tierChangeWording === null || tierChangeWording === void 0 ? void 0 : tierChangeWording.trim()) ? "." : " ".concat(tierChangeWording))),
                    this.renderRenewalWording(interaction))));
        }
        else if (refund > 0 && !annualPremiumType) {
            panelMessage.push(React.createElement(React.Fragment, null,
                React.createElement(AnnualMotorMtaExcessChangeBanner_1.AnnualMotorMtaExcessChangeBanner, { interaction: interaction }),
                React.createElement("div", { className: "panel policy-change-price" },
                    React.createElement("div", { className: "mb-0 font-weight-bold" },
                        React.createElement("div", { className: "price font-family-display font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(refund)),
                        React.createElement("p", null,
                            React.createElement("span", null, "refund "),
                            "for adding ",
                            additionalDriversNames,
                            " to your car policy. The amount will be deducted from the outstanding balance and spread evenly over the remaining ",
                            " ",
                            "monthly payments. ",
                            tierChangeWording)),
                    this.renderRenewalWording(interaction))));
        }
        else {
            panelMessage.push(React.createElement("div", { className: "policy-change-price" },
                React.createElement(AnnualMotorMtaExcessChangeBanner_1.AnnualMotorMtaExcessChangeBanner, { interaction: interaction }),
                React.createElement("div", { className: "panel mb-4 reset-margins font-weight-bold" },
                    React.createElement("p", null,
                        React.createElement("span", null, "Good news, "),
                        "there is no additional cost to add ",
                        additionalDriversNames,
                        " to your car policy. ",
                        tierChangeWording)),
                this.renderRenewalWording(interaction)));
        }
        return (React.createElement(React.Fragment, null, panelMessage));
    };
    AnnualMotorAddAdditionalDriverPayWidget.prototype.addAdditionalDriverToVehicleDrivers = function () {
        var _this = this;
        var interaction = this.props.engine.getInteraction();
        var newAdditionalDriversCount = interaction.additionalDrivers.length - parseInt(window.sessionStorage.getItem("initialAdditionalDriversNumber"), 10);
        var additionalDrivers = interaction.additionalDrivers.slice(-newAdditionalDriversCount);
        var vehicle = interaction.vehicles[0];
        var carDrivers = vehicle.driverIds;
        additionalDrivers.forEach(function (driver) {
            var additionalDriverNotAddedToVehiclesDrivers = !carDrivers.includes(driver.personId);
            if (additionalDriverNotAddedToVehiclesDrivers) {
                vehicle.driverIds.push(driver.personId);
                _this.props.interaction.numberOfAdditionalDrivers = interaction.additionalDrivers.length;
                vehicle.numberOfDrivers += 1;
            }
        });
    };
    AnnualMotorAddAdditionalDriverPayWidget.prototype.renderRenewalWording = function (interaction) {
        if (interaction.uistate.renewalWindow) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement("p", { className: "font-weight-semi-bold mb-0" },
                        "This means your next year's renewal price will be ",
                        (0, commonFunctions_1.getAmountToDisplay)(interaction.uistate.totalRenewalAmount)))));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    AnnualMotorAddAdditionalDriverPayWidget.prototype.getMonthlyPaymentWording = function (monthlyPaymentsSpread) {
        return monthlyPaymentsSpread > 0 ? "and the remaining balance of ".concat((0, commonFunctions_1.getAmountToDisplay)(monthlyPaymentsSpread), " by monthly payments") : "";
    };
    return AnnualMotorAddAdditionalDriverPayWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualMotorAddAdditionalDriverPayWidget = AnnualMotorAddAdditionalDriverPayWidget;
//# sourceMappingURL=AnnualMotorAddAdditionalDriverPayWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AnnualMotorAddAdditionalDriverPayWidget.js
// module id = 3203
// module chunks = 0